import * as types from '../types.js';

export default {

	html: `
		<style>
			#create-lots .type	{ width: 100%;	}
			#create-lots #note	{ width: 30rem;	}
		</style>
		<form id="create-lots" class="form" autocomplete="off">
			<div class="title">
				Gerar lotes para <span id="count"></span> notas
			</div>
			<div class="mtl">
				<label class="type" title="Finalidade do lote">Tipo de lote
					<select id="type" required>
						<option value="-1"></option>
						<option value="1">Autorização</option>
						<option value="2">Correção</option>
						<option value="3">Cancelamento</option>
					</select>
				</label>
			</div>
			<div>
				<label>Correção ou justificativa do cancelamento
					<textarea id="note" rows="4" placeholder="Cancelamento: mínimo 15 caracteres (SEFAZ). Carta de correção: texto da correção."></textarea>
				</label>
			</div>
			<div class="mtm">
				<button class='bn_Escape button'>Cancelar</button>
				<button class='bn_Enter button'>Gerar</button>
			</div>
		</form>
	`,

	form: 
	{
		selector: '#create-lots',
		init(formset)
		{
			formset.form.eraseValues();
			Object.getPrototypeOf(this).init.call(this);
		},
	},
	
	fields: [
		{ properties: { selector: '#type' }, types: [types.select()] },
		{ properties: { selector: '#note' }, types: [] },
	]

};

